import { gql } from '@apollo/client';

const schema = {
  current: {
    name: 'paymentType',
    serviceName: 'auth',
    query: gql`
      query paymentType($ids: [String]) {
        paymentType(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
